export class RedeemUrl {
    public static readonly listRedeem: string = "/api/v1/redeems";
    public static readonly listRedeemable: string = "/api/v1/redeemable-list";
    public static readonly createRedeem: string = "/api/v1/redeem-histories";
}